import { useLocation, useNavigate } from 'react-router-dom';

import { createTripGroup, readTripGroupPrompts } from '@api/trip_groups';
import { Breadcrumbs } from '@utilities';

import Builder from '../../components/Builder';
import Column from '../../layouts/Column';

const CreateTripGroup = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (
    <Column>
      <Breadcrumbs />
      <Builder
        create={createTripGroup}
        documentId="trip-group"
        onSubmit={() => navigate('/dashboard/workspace/trip-groups')}
        read={() => readTripGroupPrompts({ search, transform: false })}
        type="Trip Group"
      />
    </Column>
  );
};

export default CreateTripGroup;
